import { MAP_PIPELINE_DISCLAIMER_TEXT } from '@buxus/shared'

/** Legal copy shown directly under every map surface (see `MapSurface`). */
export function MapPipelineDisclaimer() {
  return (
    <p className="map-pipeline-disclaimer" role="note">
      {MAP_PIPELINE_DISCLAIMER_TEXT}
    </p>
  )
}
